import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setLoadingState } from "../redux/loadingSlice";

const useAppInitialization = () => {
  const dispatch = useDispatch();
  const { employeeLogin, organisationLogin, adminLogin } = useSelector(
    (state) => state.auth,
  );

  const location = useLocation();

  const [firstLoad, setFirstLoad] = useState(true);

  const isLoggedIn = employeeLogin || organisationLogin || adminLogin;
  //
  useEffect(() => {
    dispatch(setLoadingState(true));
    const timer = setTimeout(() => {
      dispatch(setLoadingState(false));
      if (firstLoad) {
        setFirstLoad(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [dispatch, location, firstLoad]);

  return { isLoggedIn };
};

export default useAppInitialization;
